import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, CalendarCheck } from "lucide-react";
import { Logo } from "../components/marketing/Logo";
import { useDemoModal } from "../components/marketing/DemoModal";

const AuthPlaceholder = ({ mode }) => {
    const { openDemo } = useDemoModal();
    const isSignup = mode === "signup";
    return (
        <div
            data-testid={isSignup ? "signup-page-container" : "login-page-container"}
            className="bg-grid-faint relative flex min-h-screen items-center justify-center overflow-hidden bg-[#F7FEF9] px-4"
        >
            <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-[560px] -translate-x-1/2 rounded-full bg-[#16A34A]/10 blur-3xl" />
            <div className="relative w-full max-w-md rounded-3xl border border-[#E5E7EB] bg-white p-9 text-center shadow-xl shadow-slate-900/[0.05]">
                <Link to="/" className="inline-flex" aria-label="Back to Kryvo home">
                    <Logo />
                </Link>
                <h1 className="mt-7 font-display text-2xl font-extrabold tracking-tight text-[#111827]">
                    {isSignup ? "The Kryvo app is almost ready" : "Welcome back — almost"}
                </h1>
                <p className="mt-3 text-[15px] leading-relaxed text-[#64748B]">
                    {isSignup
                        ? "Self-serve sign-up opens shortly. Book a demo and we'll set up your workspace personally — data, pipelines and all."
                        : "The Kryvo CRM app launches soon. If your team already has a workspace, your invite link will take you straight in."}
                </p>
                <div className="mt-8 grid gap-3">
                    <button
                        onClick={openDemo}
                        data-testid={isSignup ? "signup-btn-book-demo" : "login-btn-book-demo"}
                        className="group flex items-center justify-center gap-2 rounded-full bg-[#16A34A] px-6 py-3.5 text-sm font-semibold text-white transition-all hover:bg-[#15803D]"
                    >
                        <CalendarCheck className="h-4 w-4" />
                        Book a Demo
                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </button>
                    <Link
                        to="/"
                        data-testid={isSignup ? "signup-btn-back-home" : "login-btn-back-home"}
                        className="flex items-center justify-center gap-2 rounded-full border border-[#E5E7EB] px-6 py-3.5 text-sm font-semibold text-[#111827] transition-colors hover:border-[#16A34A]/40 hover:text-[#15803D]"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Back to website
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AuthPlaceholder;
